export default __webpack_public_path__ + "static/media/yahtzeeGame.f9613a76.jpg";